
import React from 'react';
import { Page, Text, View, Document, Image, Svg, Line, StyleSheet } from '@react-pdf/renderer';
import img from "../../assets/logos/logo.png";
const primaryColor = "#ec6623";
const secondaryColor = "#ccc";

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: "4%",
    paddingBottom: "4%",
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  reportHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "2%"
  },

  reportHeaderImg: {
    width: "110px",
    position: "absolute",
    top: "0%",
    right: "2%",
  },

  reportHeaderText: {
    textAlign: "left",
    fontSize: "34px",
    marginLeft: "10px"
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: "8%",
    marginBottom: "3%",
    marginLeft: 0,
    marginRight: 0,
  },

  headerLeftContainer: {
    flex: 2.5,
    display: 'flex',
    marginLeft: "10px"
  },
  headerLeftContainerFirstText: {
    fontSize: "13px",
    color: "#3F3F3E",
    width: "96%",
    lineHeight: 1.5,
    margin: "3% 0 5% 0"
  },
  headerLeftContainerSecondText: {
    fontSize: 13,
    color: "#3F3F3E",
    textAlign: "justify",
    width: "96%",
    marginBottom: "1%",
    lineHeight: 1.5,
    fontWeight: "bold"
  },
  barView: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
    margin: "1% 0 ",
    padding: "0 ",
  },
  barContainer: {
    flex: 1,
    margin: "10px ",
  },
  barTitle: {
    fontSize: "10px",
    margin: "3px 0",
    color: "#3F3F3E",
  },
  barText: {
    textAlign: "justify",
    fontSize: "9.5px",
    width: "95%",
    lineHeight: 1.5,
    padding: "0 1px",
    color: "#3F3F3E",
    marginTop: "-8px"
  },
  barChart: {
    width: 180,
    height: 20,
  },
  barView1: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    flexGrow: 1,
    justifyContent: "flex-start",
    margin: "1% 0 ",
    padding: "0 ",
  },
  barContainer1: {
    width: "22%",
    marginBottom: "3%",
    marginRight: "3%",
  },


});

// Create Document Component
const PDF = ({ result }) => {

  const firstFourPA = result.bars.slice(1, 5);
  const secondBarsList = result.bars.slice(5);

  return (
    <Document>
      <Page orientation="landscape" size="A4" style={styles.page}>
        <View style={styles.reportHeaderContainer}>
          <Text style={styles.reportHeaderText}>
            Ergebnisübersicht  | Soft Skills
          </Text>
          <Image src={img} style={styles.reportHeaderImg} />
        </View>

        <View style={styles.headerContainer}>
          <View style={styles.headerLeftContainer}>

            <Text style={styles.headerLeftContainerFirstText}>
              Fach- und Methodenkompetenzen – auch Hard Skills genannt – sind Qualifikationen, die man durch schulische und berufliche Aus- und Weiterbildung erwerben kann. Sie bauen meist aufeinander auf und nehmen mit ansteigender Berufserfahrung zu. Unter Soft Skills versteht man demgegenüber Persönlichkeitseigenschaften, Fähigkeiten und Einstellungen, die unabhängig von fachlichen und methodischen Kompetenzen sind. Sie sind funktions- und berufsübergreifend und runden dein Profil entsprechend ab.
            </Text>

            <Text style={styles.headerLeftContainerSecondText}>
              Auf Basis deines Antwortverhaltens soll dir der vorliegende Report Auskunft über deine individuelle Ausprägung hinsichtlich relevanter Soft Skills geben.
            </Text>
          </View>
        </View>

        <View style={styles.barView}>
          {
            firstFourPA ? (
              firstFourPA.map(bar => {
                return (
                  <View style={styles.barContainer} key={bar.title}>
                    <Text style={styles.barTitle}>
                      {bar.title ? bar.title.toUpperCase() : null}
                    </Text>
                    <Svg height={20} width={300} style={styles.barChart} >
                      <Line
                        x1="200"
                        y1={0}
                        x2={0}
                        y2={0}
                        strokeWidth={10}
                        stroke={secondaryColor}
                      />
                      <Line
                        x1={Number.isFinite(Number(bar.score)) ? Number(bar.score) * 2 : 0}
                        y1={0}
                        x2={0}
                        y2={0}
                        strokeWidth={10}
                        stroke={primaryColor}
                      />
                    </Svg>
                    <Text style={styles.barText} >
                      {bar.text}
                    </Text>
                  </View>
                )
              })
            ) : (

              <Text  >
                No data
              </Text>
            )
          }
        </View>
      </Page>

      <Page orientation="landscape" size="A4" style={styles.page} >
        <View style={styles.barView1}>
          {

            secondBarsList ? (
              secondBarsList.map(bar => {
                return (
                  <View style={styles.barContainer1} key={bar.title}>
                    <Text style={styles.barTitle}>
                      {bar.title ? bar.title.toUpperCase() : null}
                    </Text>
                    <Svg height={20} width={300} style={styles.barChart} >
                      <Line
                        x1={200}
                        y1={0}
                        x2={0}
                        y2={0}
                        strokeWidth={10}
                        stroke={secondaryColor}
                      />
                      <Line
                        x1={Number.isFinite(Number(bar.score)) ? Number(bar.score) * 2 : 0}
                        y1={0}
                        x2={0}
                        y2={0}
                        strokeWidth={10}
                        stroke={primaryColor}
                      />
                    </Svg>
                    <Text style={styles.barText} >
                      {bar.text}
                    </Text>
                  </View>
                )
              })) : (

              <Text  >
                No data
              </Text>
            )
          }
        </View>
      </Page>
    </Document>
  );
}

export default PDF;